import React, { Component } from 'react'
import styled, { css } from 'styled-components/macro'
import { subtitle1 } from 'styles/mixins/textstyles'
import Spacer from 'components/misc/Spacer'
import { Collapse } from 'react-collapse'

const FaqItem = styled.div`
  padding: .8rem 0;
  padding-left: 0;
  text-align: left;
`

const FaqTitle = styled.div`
  ${props => subtitle1(props.theme.colors.primaryBase)}

  display: block;
  text-decoration: none;
  position: relative;
  cursor: pointer;
  padding-left: .8rem;
  padding-left: 2.4rem;

  &:before {
    content: '';
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    margin-top: .4rem;
    margin-right: .8rem;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: .8rem 0 .8rem 1.2rem;
    border-color: transparent transparent transparent ${props => props.theme.colors.primaryBase};
    transition: all 150ms ease;
    transform-origin: center center;
    transform: scale(.75);

    ${props => props.faintNotch && css`
      opacity: .6;
    `}
    
    ${props => props.open && css`
      transform: rotate(90deg);
    `}
  }
`

const FaqBody = styled(Collapse)`
  ${props => subtitle1(props.theme.colors.greyBase)} 
  padding-left: .8rem;

  p {
    font-size: 1.6rem;
  }
`

export default class Faq extends Component {

  state = {
    open: false
  }

  handleToggle = event => {
    event.preventDefault()
    this.setState({ open: !this.state.open })
  }

  render() {
    const { title, className, children, faintNotch } = this.props
    const { open } = this.state
    return (
      <FaqItem className={className}>
        <FaqTitle open={open} faintNotch={faintNotch} onClick={this.handleToggle}>{title}</FaqTitle>
        <FaqBody isOpened={open}>
          <Spacer height=".8rem" />
          <p>{children}</p>
        </FaqBody>
      </FaqItem>
    )
  }
}